// @ts-nocheck
import * as React from 'react';
import classNames from 'classnames';
import { defaultClassPrefix, getUnhandledProps, prefix } from './utils';
import TableContext from './TableContext';
const propTypeKeys = [
    'fixed',
    'width',
    'height',
    'left',
    'style',
    'className',
    'classPrefix',
    'rowDraggable',
    'snapshot',
    'provided',
];
class CellGroup extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.addPrefix = (name) => prefix(this.props.classPrefix)(name);
    }
    render() {
        const { fixed, width, left, height, style, classPrefix, className, children, rowDraggable, provided, snapshot, ...rest } = this.props;
        const classes = classNames(classPrefix, className, {
            [this.addPrefix(`fixed-${fixed || ''}`)]: fixed,
            [this.addPrefix('scroll')]: !fixed,
        });
        const styles = {
            width,
            height,
            ...style,
        };
        const unhandledProps = getUnhandledProps(propTypeKeys, rest);
        let childArr = [];
        if (rowDraggable) {
            React.Children.forEach(children, child => {
                childArr.push(React.cloneElement(child, {
                    provided,
                    isDragging: snapshot ? snapshot.isDragging : false,
                }));
            });
        }
        const cloneChildren = rowDraggable ? childArr : children;
        return (React.createElement(TableContext.Consumer, null, ({ translateDOMPositionXY }) => {
            if (translateDOMPositionXY && !fixed) {
                translateDOMPositionXY(styles, left, 0);
            }
            return (React.createElement("div", Object.assign({}, unhandledProps, { className: classes, style: styles }), cloneChildren));
        }));
    }
}
CellGroup.defaultProps = {
    classPrefix: defaultClassPrefix('performance-table-cell-group'),
};
export default CellGroup;
